import React from 'react';

import Cv2HotelPlannerCard from './components/Cv2';
import HotelPlannerCard from './components/HotelPlannerCard';
import { Room, TransientRoomsProvider } from './contexts/TransientRooms';

interface Props {
  weddingLocation: string;
  weddingDate: string;
  exclude: string[];
  onClick: (room: Room) => void;
  newVersion?: boolean;
  useCarousel?: boolean;
}

const HotelPlannerTransientRooms: React.FC<Props> = ({
  weddingLocation,
  weddingDate,
  exclude,
  onClick,
  newVersion = false,
  useCarousel = false,
}) => (
  <TransientRoomsProvider weddingLocation={weddingLocation} weddingDate={weddingDate} exclude={exclude}>
    {newVersion ? (
      <Cv2HotelPlannerCard onClick={onClick} useCarousel={useCarousel} />
    ) : (
      <HotelPlannerCard onClick={onClick} />
    )}
  </TransientRoomsProvider>
);

export { default as HotelPlannerLogo } from './components/HotelPlannerLogo';
export * from './contexts/TransientRooms';
export default HotelPlannerTransientRooms;
